import {css} from 'lit';

import {defaultStyles} from '../../../components/input.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  sizeGen: () => '',
});

export default {styles};
